var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['no-img']},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }